export function componentParentFactory(component) {
  return component.parent;
};
